import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  text: {
    // Overrides MUI's scale(1, 0.6) for more accurate text reflection
    transform: 'scale(1, 0.70)',
  },
  borderRadius: {
    borderRadius: '50px',
  },
}));

export default useStyles;
